<template lang="pug">
.composition.composition--padded.composition--padded-flush-top.app-trending(v-if="loaded && !!terms.length && !error")
	h2.app-trending__heading Trending Searches
	.app-trending__terms 
		a(v-for="term in terms" :key="term.name" href @click.prevent="executeTermSearch(term)").app-trending__term
			span.app-trending__term-text {{ term.name }}
</template>

<script>
export default {
	name: 'TrendingSearches',
	props: {
		executeSearch: Function,
		setQuery: Function,
	},
	components: {},
	data() {
		return {
			terms: [],
			loaded: false,
			error: false,
		};
	},
	computed: {},
	methods: {
		async getSearchTerms() {

			let url = this.config.trendingSearchEndpoint;
			let params = new URL(document.location).searchParams;
			if(params.has('query')) {
				url += `&currentTerm=${params.get('query')}`;
			}

			fetch(url)
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					this.terms = data.data.items;
					this.loaded = true;
				})
				.catch((error) => {
					this.error = true;
					console.error(error);
				});

		},
		executeTermSearch(term) {
			this.setQuery(term.name);
			this.executeSearch();
		},
	},
	created() {
		this.getSearchTerms();
	},
	mounted() { },
};
</script>

<style lang="scss" scoped>
.app-trending {
	grid-area: 1/1/1/-1;
	
	&__heading {
		@include fluid(font-size, 1.25rem, 1.875rem);
	}
	&__terms {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
	}
	&__term:is(a) {
		text-decoration: none;
		background: $white;
		border-radius: 10rem;
		font-size: 0.875rem;
		font-weight: 600;
		padding: 0.5rem 1rem;
		transition: 0.14s ease;

		&:hover {
			text-decoration: none;
			color: $white;
			span {
				color: $white;
			}
		}
		
		.page--ORG & {
			color: $brightBlueAltOrg;
			border: solid 1px $brightBlueAltOrg;
			&:hover {
				background: $brightBlueAltOrg;
			}
		}
		.page--TSP & {
			color: $primary600tsp;
			border: solid 1px $primary600tsp;
			&:hover {
				background: $primary600tsp;
			}
		}
		.page--TXC & {
			color: $primary700txc;
			border: solid 1px $primary700txc;
			&:hover {
				background: $primary700txc;
			}
		}
		.page--BOB & {
			color: $primary700bob;
			border: solid 1px $primary700bob;
			&:hover {
				background: $primary700bob;
			}
		}
		.page--BUY & {
			color: $primary700buy;
			border: solid 1px $primary700buy;
			&:hover {
				background: $primary700buy;
			}
		}
	}
}
</style>